import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { EquationVariableGroupService } from '../proxy/general/controllers/equation-variable-group.service';

FieldBuilder.setNamespace('General');

export const EQUATIONVARIABLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('description', 'Entity.EquationVariable.Description')
    .required()
    .minLength(1)
    .maxLength(80)
    .build(),
  FieldBuilder
    .text('variable', 'Entity.EquationVariable.Variable')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .foreignKey('equationVariableGroupId', 'Entity.EquationVariableGroup', EquationVariableGroupService)
    .required()
    .displayFromNested('equationVariableGroup.name')
    .sortBy('equationVariableGroup.name')
    .build(),
];

export const EQUATIONVARIABLE_CONFIG = {
  entityName: 'EquationVariable',
  localizationKey: 'General::Entity.EquationVariable',
  fields: EQUATIONVARIABLE_FIELDS,
  permission: 'ControllingLiquidations.EquationVariables',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
